import { createSelector } from "reselect";

import { commonSlice } from "./slice";

const selectCommonState = (state) => state[commonSlice.name];

export const selectCommonModals = createSelector(selectCommonState, (commonState) => commonState.modals);

export const selectOTPModal = createSelector(selectCommonModals, (modals) => modals.otpModal);

export const selectKeyboardShortcutsModal = createSelector(
  selectCommonModals,
  (modals) => modals.keyboardShortcutsModal,
);

export const selectClipEditorSidebarFiltersModal = createSelector(
  selectCommonModals,
  (modals) => modals.clipEditorSidebarFiltersModal,
);

export const selectClipEditorContentDeleteModal = createSelector(
  selectCommonModals,
  (modals) => modals.clipEditorContentDeleteModal,
);

export const selectClipEditorMediaContentPreviewModal = createSelector(
  selectCommonModals,
  (modals) => modals.clipEditorMediaContentPreviewModal,
);

export const selectShowExportUsageReportModal = createSelector(
  selectCommonModals,
  (modals) => modals.exportUsageReportModal,
);
export const selectShowSendToWorkspaceModal = createSelector(
  selectCommonModals,
  (modals) => modals.editingSidebarSendToWorkspaceModal,
);

export const selectShowUploadBumperModal = createSelector(selectCommonModals, (modals) => modals.uploadBumperModal);
